import {useMemo} from 'react';

import {selectEntityData} from 'modules/data';
import {IReferenceEntityData} from 'modules/data/data-types';
import {EEntityType} from 'shared/constants/entities';
import {ILookupEntry} from 'shared/types/lookups';
import {useAppSelector} from 'store/config/hooks';

/**
 * Хук для проверки выбранного значения в lookup по lookupCode
 * @param lookupUrl - URL для загрузки lookup данных
 * @param lookupCode - Код lookup для поиска
 * @returns Функция для проверки, совпадает ли выбранный ID с ID элемента с указанным lookupCode
 */
export const useLookupCheck = (lookupUrl: string, lookupCode: string) => {
    const lookupData = useAppSelector(
        selectEntityData(lookupUrl, EEntityType.REFERENCE)
    ) as IReferenceEntityData | undefined;
    
    const lookupItem = useMemo(() => {
        if (!lookupData?.rows || lookupData.rows.length === 0) {
            return null;
        }
        return lookupData.rows.find((item) => (item as unknown as ILookupEntry).lookupCode === lookupCode) as ILookupEntry | undefined;
    }, [lookupData, lookupCode]);
    
    const checkSelectedId = (selectedId: number | null | undefined): boolean => {
        if (!lookupItem || !selectedId) return false;
        return lookupItem.id === selectedId;
    };
    
    return checkSelectedId;
};

